<h1 mat-dialog-title>Name Id Type Range</h1>
<div mat-dialog-content>
  <mat-form-field floatLabel="never" class="full-width">
    <mat-label>Start</mat-label>
    <mat-select [(value)]="startNameIdType">
      <mat-option *ngFor="let nameIdType of nameIdTypes" [value]="nameIdType.Code" class="ta-settings-nameidstart">
        {{nameIdType.Code}} - {{nameIdType.Description}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field floatLabel="never" class="full-width">
    <mat-label>End</mat-label>
    <mat-select [(value)]="endNameIdType" [disabled]="!startNameIdType">
      <mat-option *ngFor="let nameIdType of nameIdTypes" [value]="nameIdType.Code" class="ta-settings-nameidend">
        {{nameIdType.Code}} - {{nameIdType.Description}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<mat-label *ngIf="inValidRange" class="error-block">*Please select valid range.</mat-label>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()"
    class="mat-mdc-button-whiteBackground-BlackText mat-mdc ta-settings-nameidcancel">Cancel</button>
  <button mat-raised-button color="primary" (click)="saveRange()" class="ta-settings-nameidsave">Save</button>
  <button mat-button color="warn" (click)="reset()"
    class="mat-mdc-button-whiteBackground-RedText ta-settings-nameidreset">Reset</button>
</div>